import dynamic from 'next/dynamic';

import {
  getAssetFromStoryblok,
  sbEditable,
  type SBProps,
  type StoryblokAsset,
} from '../../../../utils';

const ResponsiveImage = dynamic(() =>
  import('@natu/ui/ResponsiveImage').then(mod => mod.ResponsiveImage),
);

interface SBSupportItemProps {
  title?: string;
  cardTitle?: string;
  cardDescription?: string;
  cardImage?: StoryblokAsset;
}

export const SBSupportItem = ({ blok }: SBProps<SBSupportItemProps>) => {
  const { cardDescription, cardImage, cardTitle } = blok;

  const image = getAssetFromStoryblok(cardImage, { type: 'image' });

  if (!cardDescription && !cardImage && !cardTitle) return null;

  return (
    <div className="lg:bg-naturaily-azureGray rounded-xl lg:p-8" {...sbEditable(blok)}>
      {image.src && (
        <ResponsiveImage
          {...image}
          className="mb-6 hidden max-h-64 w-full rounded-2xl object-cover lg:block"
        />
      )}
      <p className="text-primary-600 mb-6 hidden font-semibold lg:block">Our answer</p>
      <p className="mb-4 text-xl font-semibold text-gray-900 lg:mb-6 xl:text-2xl">{cardTitle}</p>
      <p className="text-base text-gray-600 xl:text-lg">{cardDescription}</p>
    </div>
  );
};
